import React from 'react';
import cn from 'classnames';
import IconWrapper from '@components/ui/Icons';
import { useTranslation } from 'next-i18next';
import { useUI } from '@context/GlobalUIContext';

import styles from './MarketplaceSellerInfo.module.scss';

interface MarketplaceSellerInfoProps {
  sellerName: string;
  classNames?: string;
}

const MarketplaceSellerInfo = ({
  sellerName,
  classNames,
}: MarketplaceSellerInfoProps) => {
  const { t } = useTranslation('common');
  const { openMarketplaceSellerModal } = useUI();

  return (
    <div className={cn(styles.marketplaceSellerContainer, classNames)}>
      <IconWrapper
        icon="package"
        width={24}
        height={24}
        fill="white"
        classNames={styles.marketplaceSellerIcon}
      />
      <button
        className={styles.marketplaceSellerButton}
        onClick={() => {
          openMarketplaceSellerModal({ sellerName: sellerName });
        }}
      >
        {t('marketplacer.soldAndShippedBy', { sellerName })}
      </button>
    </div>
  );
};
export default MarketplaceSellerInfo;
